module.exports = __webpack_public_path__ + "img/ico_error.cf32bd6a.svg";